.root {
  --typography--size: var(--theme--typo--paragraph--size);
  --typography--lh: var(--theme--typo--paragraph--line-height);
  --typography--weight: var(--theme--typo--paragraph--weight);

  &.type_h1 {
    --typography--size: var(--theme--typo--h1--size);
    --typography--lh: var(--theme--typo--h1--line-height);
    --typography--weight: var(--theme--typo--h1--weight);
  }

  &.type_h2 {
    --typography--size: var(--theme--typo--h2--size);
    --typography--lh: var(--theme--typo--h2--line-height);
    --typography--weight: var(--theme--typo--h2--weight);
  }

  &.type_h3 {
    --typography--size: var(--theme--typo--h3--size);
    --typography--lh: var(--theme--typo--h3--line-height);
    --typography--weight: var(--theme--typo--h3--weight);
  }

  &.type_h4 {
    --typography--size: var(--theme--typo--h4--size);
    --typography--lh: var(--theme--typo--h4--line-height);
    --typography--weight: var(--theme--typo--h4--weight);
  }

  &.type_paragraph {
    --typography--size: var(--theme--typo--paragraph--size);
    --typography--lh: var(--theme--typo--paragraph--line-height);
    --typography--weight: var(--theme--typo--paragraph--weight);
  }

  &.type_button {
    --typography--size: var(--theme--typo--button--size);
    --typography--lh: var(--theme--typo--button--line-height);
    --typography--weight: var(--theme--typo--button--weight);
  }

  &.type_label {
    --typography--size: var(--theme--typo--label--size);
    --typography--lh: var(--theme--typo--label--line-height);
    --typography--weight: var(--theme--typo--label--weight);
  }

  &.type_caption {
    --typography--size: var(--theme--typo--caption--size);
    --typography--lh: var(--theme--typo--caption--line-height);
    --typography--weight: var(--theme--typo--caption--weight);
  }

  &.type_meta {
    --typography--size: var(--theme--typo--meta--size);
    --typography--lh: var(--theme--typo--meta--line-height);
    --typography--weight: var(--theme--typo--meta--weight);
  }

  &.type_inherit {
    --typography--size: inherit;
    --typography--lh: inherit;
    --typography--weight: inherit;
  }

  &.bold {
    font-weight: var(--theme--font--weight-bold);
  }

  &.center {
    text-align: center;
  }

  &.uppercase {
    text-transform: uppercase;
  }

  &.capitalize {
    text-transform: capitalize;
  }

  &.noWrap {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap: nowrap;
  }

  &.preWrap {
    white-space: pre-wrap;
  }

  &.underline {
    text-decoration: underline;
  }

  & {
    color: var(--typography--color);
    appearance: none;
    margin: 0;
    padding: 0;
    font-family: var(--theme--font--family);
    font-size: var(--typography--size);
    line-height: var(--typography--lh);
    font-weight: var(--typography--weight);
  }

  img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
  }
}